const initialState = {
    idlogin: null,
    idusuario: null,
    idep: null,
    idestabelecimento: null,
    idsim: null,
    appname: 'SGSIM-WEB',
    appver: '1.26.0624',
    ckperfilgestor: false,
    ckperfilsupervisor: false,
    ckperfilinspetor: false,
    ckperfilestabelecimento: false,
    ckperfilrt: false,
    idperfil: null,
    nmperfil: '',
    nmusuario: '',
    nmep: '',
    nmestabelecimento: '',
    nmsim: '',
    latitude: 0,
    longitude: 0,
    itensPorPagina: 15,
    showAcoesEstabelecimento: false,
    showSelectEstabelecimento: false,
    showSelectSim: false,

    atividade: {
        id: 0,
        cdatividade: 0,
        nmatividade: '',
        ckmpleite: false,
        ckmpmel: false,
    },
};

export const globalStore = {
    ...structuredClone(initialState),

    clear() {
        Object.assign(this, structuredClone(initialState));
    }
};